module.exports = __webpack_public_path__ + "fonts/iconfont.41a4386c.ttf";